import axios from 'axios'

export default {
  state: {
    clients: [],
    selectedClientId: null
  },
  actions: {
    async fetchClients ({ rootState, commit }) {
      try {
        const response = await axios.get(`${rootState.apiURL}/clients/clients`)
        commit('setClients', response.data)
      } catch (err) {
        console.error('Error fetching clients:', err)
        commit('addMessageAxios', { message: 'Erreur lors du chargement des clients', isError: true })
      }
    },
    async createClient ({ rootState, commit, dispatch }, payload) {
      try {
        const response = await axios.post(`${rootState.apiURL}/clients/clients`, {
          name: payload.name
        })
        commit('addMessageAxios', { message: 'Client créé avec succès' })
        dispatch('fetchClients')
        return response.data
      } catch (err) {
        console.error('Error creating client:', err)
        const errorMsg = err.response?.data?.error || 'Erreur lors de la création du client'
        commit('addMessageAxios', { message: errorMsg, isError: true })
        throw err
      }
    },
    async updateClient ({ rootState, commit, dispatch }, payload) {
      try {
        await axios.patch(`${rootState.apiURL}/clients/clients/${payload.id}`, {
          name: payload.name
        })
        commit('addMessageAxios', { message: 'Client mis à jour avec succès' })
        dispatch('fetchClients')
      } catch (err) {
        console.error('Error updating client:', err)
        const errorMsg = err.response?.data?.error || 'Erreur lors de la mise à jour du client'
        commit('addMessageAxios', { message: errorMsg, isError: true })
        throw err
      }
    },
    async deleteClient ({ rootState, commit, dispatch }, payload) {
      const confirmed = confirm('Voulez-vous vraiment supprimer ce client ?')
      if (!confirmed) return

      try {
        await axios.delete(`${rootState.apiURL}/clients/clients/${payload.id}`)
        commit('addMessageAxios', { message: 'Client supprimé avec succès' })
        dispatch('fetchClients')
      } catch (err) {
        console.error('Error deleting client:', err)
        const errorMsg = err.response?.data?.error || 'Erreur lors de la suppression du client'
        commit('addMessageAxios', { message: errorMsg, isError: true })
        throw err
      }
    },
    async updateOrderClient ({ rootState, commit }, payload) {
      try {
        await axios.patch(`${rootState.apiURL}/orders/${payload.orderId}/client`, {
          clientId: payload.clientId
        })
        commit('addMessageAxios', { message: 'Client de la commande mis à jour avec succès' })
      } catch (err) {
        console.error('Error updating order client:', err)
        const errorMsg = err.response?.data?.error || 'Erreur lors de la mise à jour du client'
        commit('addMessageAxios', { message: errorMsg, isError: true })
        throw err
      }
    }
  },
  mutations: {
    setClients (state, payload) {
      state.clients = payload
    },
    setSelectedClientId (state, payload) {
      state.selectedClientId = payload
    }
  },
  getters: {
    clients: state => state.clients,
    selectedClientId: state => state.selectedClientId,
    selectedClient: state => {
      if (!state.selectedClientId) return null
      return state.clients.find(c => c.id === state.selectedClientId)
    }
  }
}
